/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Time_Display_RelativeInputs */

const fr_settings_time_display_relative = /** @type {(inputs: Settings_Time_Display_RelativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure relative`)
};

const en_settings_time_display_relative = /** @type {(inputs: Settings_Time_Display_RelativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relative time`)
};

/**
* | output |
* | --- |
* | "Relative time" |
*
* @param {Settings_Time_Display_RelativeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_time_display_relative = /** @type {((inputs?: Settings_Time_Display_RelativeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Time_Display_RelativeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_time_display_relative(inputs)
	return en_settings_time_display_relative(inputs)
});